<template>
    <div class="md chart">
        <div class="interval">
            <div class="proportion" :style="styleSet">
                <div class="content">
                    <canvas ref="chart" @click="action"></canvas>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            obj: {
                type: Object,
                required: true
            },
            height: {
                required: false
            }
        },
        data: function(){
            
            return {
                chart: null,
                clone: null
            }
        },
        computed: {
            styleSet: function(){

                let $styleSet = {};

                let _height = this.height;

                if( _height && typeof _height === 'number' ) {
                    $styleSet.height = _height +'px';
                }

                return $styleSet;
            }
        },
        watch: {
            obj: {
                handler: function(){
                    this.updateClone();
                },
                deep: true
            },
        },
        methods: {
            createChart: function(){
                let $clone = this.clone;

                if( $clone === null ) {
                    $clone = _.cloneDeep(this.obj);
                }

                this.chart = new this.$chart(this.$refs.chart, $clone);

                window.hhChart = this.chart;
            },
            updateClone: function(){
                this.clone = _.cloneDeep(this.obj);

                this.updateChart();
            },
            updateChart: function(){
                this.chart.destroy();
                this.createChart();
            },
            action: function(e){
                let $element = this.chart.getElementAtEvent(e);

                if( this.obj && this.obj.action && typeof this.obj.action === 'function' && $element.length ) {
                    let $chartData = this.chart.data,
                        _index = $element[0]['_index'],
                        _dataName = $chartData.datasets[0].label,
                        _label = $chartData.labels[_index],
                        _value = $chartData.datasets[0].data[_index];

                    let $chart = {
                            dataName: _dataName,
                            label: _label,
                            value: _value
                        }

                    this.obj.action($chart, $element, _index);
                }
            }
        },
        mounted: function(){
            this.createChart();
        }
    }
</script>

<style scoped lang="scss">

    .md.chart {

        .interval {

        }

        .proportion {
            position: relative;
            height: 50vh;

            .lo.extend & {
                height: calc(100vh - 140px);
            }

            @for $i from 2 through 5 {
        
                .lo.extend .leng_#{$i} & {
                    height: calc(#{100 / $i}vh - #{ 140 / $i }px);
                }
            }

            @include media('mobile') {
                height: calc(100vh - 140px);
            }
        }

        .content {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            overflow: hidden;
        }

        canvas {

        }
    }
</style>
